import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../context/AuthContext";
import useApi from "../../api/useApi";
import Button from "../Button/Button";

const AiPauseToggle = () => {
  const { user } = useContext(AuthContext);
  const { api } = useApi();
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showOptions, setShowOptions] = useState(false);

  const isAdmin = user?.is_admin;

  const fetchStatus = () => {
    if (!isAdmin) return;
    api(
      'get',
      'admin/ai/status',
      (response) => {
        setStatus(response.data);
        setIsLoading(false);
      },
      () => setIsLoading(false),
      () => setIsLoading(false)
    );
  };

  // Only fetch once on mount
  useEffect(() => {
    fetchStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  // Only render for admins
  if (!isAdmin) {
    return null;
  }

  const handlePause = (minutes = null) => {
    setIsLoading(true);
    api(
      'post',
      'admin/ai/pause',
      (response) => {
        setStatus(response.data);
        setIsLoading(false);
        setShowOptions(false);
      },
      () => setIsLoading(false),
      () => setIsLoading(false),
      { paused: true, duration_minutes: minutes }
    );
  };

  const handleResume = () => {
    setIsLoading(true);
    api(
      'post',
      'admin/ai/pause',
      (response) => {
        setStatus(response.data);
        setIsLoading(false);
      },
      () => setIsLoading(false),
      () => setIsLoading(false),
      { paused: false }
    );
  };

  if (isLoading && !status) {
    return null;
  }

  if (!status?.enabled) {
    return (
      <div className="component-ai-pause-toggle disabled">
        <span className="status-text">AI Chat uitgeschakeld</span>
      </div>
    );
  }

  return (
    <div className="component-ai-pause-toggle">
      {status.paused ? (
        <div className="paused">
          <span className="status-indicator paused"></span>
          <span className="status-text">
            AI gepauzeerd
            {status.paused_until_human && ` (${status.paused_until_human})`}
          </span>
          <Button
            label="Hervat AI"
            size="xs"
            color="green"
            onClick={handleResume}
            disabled={isLoading}
          />
        </div>
      ) : (
        <div className="active">
          <span className="status-indicator active"></span>
          <span className="status-text">AI actief</span>
          {showOptions ? (
            <div className="pause-options">
              <Button
                label="5 min"
                size="xs"
                color="grey"
                onClick={() => handlePause(5)}
                disabled={isLoading}
              />
              <Button
                label="15 min"
                size="xs"
                color="grey"
                onClick={() => handlePause(15)}
                disabled={isLoading}
              />
              <Button
                label="1 uur"
                size="xs"
                color="grey"
                onClick={() => handlePause(60)}
                disabled={isLoading}
              />
              <Button
                label="Handmatig"
                size="xs"
                color="orange"
                onClick={() => handlePause(null)}
                disabled={isLoading}
              />
              <Button
                label="Annuleer"
                size="xs"
                color="grey-ghost"
                onClick={() => setShowOptions(false)}
              />
            </div>
          ) : (
            <Button
              label="Pauzeer AI"
              size="xs"
              color="orange"
              onClick={() => setShowOptions(true)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default AiPauseToggle;